<template>
    <van-overlay :show="show" @click="close" style="z-index: 1">
    <Loading v-if="requested" />
        <div class="wrapper" @click.stop>
            <div class="block">
                <div class="header">
                    <a class="close" @click="close">
                        <van-icon name="cross" />
                    </a>
                    
                    <div class="title bg-main">
                        <span>Delivery Option</span>
                    </div>
                </div>
                
                <div class="content">
                    <div class="info" >
                        <p v-if="serviceType.delivery_service != 'delyva'" style="text-transform: uppercase;padding:10px 0 0;margin:0px">{{serviceType.delivery_service}}</p>
                        <div v-if="serviceType.delivery_service == 'delyva' || 'lalamove'" style="width:320px;margin:0 auto;text-align:start;font-size:12px;font-style:italic;word-wrap: break-word;padding:10px">{{ $t("translate.notes") }}</div>
                    </div>

                    <!-- teleport -->
                    <div v-if="serviceType.delivery_service == 'teleport'">
                        <div :key="index" v-for="(item, index) in serviceType.service_type">
                            <div :class="(disableOption && item != 'STANDARD') || (store.is_rain == 1 && item.includes('BIKE')) ? 'disable':''" @click="checkItem(item)" class="delivery">
                                <!-- <div :class="disableOption && item != 'STANDARD'? 'disable':''" @click="checkItem(item)" class="delivery"> -->
                                <div style="display: flex; align-items: center; padding: 0 16px; margin: 6px 0;">
                                    <div>
                                        <icon v-if="item == 'STANDARD'" class="buttonIcon" size="20px" name="plane"/>
                                        <icon v-else-if="item.includes('BIKE')" 
                                        :color="disableOption || (store.is_rain == 1 && item.includes('BIKE'))? '#999':'#ee2d24'" size="20px" name="motorcycle"/>
                                        <icon v-else-if="item.includes('CAR')"
                                        :color="disableOption? '#999':'#ee2d24'" size="20px" name="car"/>
                                        <!--<van-icon v-else :color="disableOption == false? '#ee2d24':''" size="20px" name="logistics" />-->
                                    </div>
                                    <div v-if="item == 'INSTANT_BIKE'" style="padding-left: 16px; text-align: left;font-size: 14px;">{{item.replace("_"," ")}} (ETA 1 Hour)</div>
                                    <div v-else-if="item == 'INSTANT_CAR'" style="padding-left: 16px; text-align: left;font-size: 14px;">{{item.replace("_"," ")}} (ETA 1 Hour)</div>
                                    <div v-else-if="item == 'FLASH_BIKE'" style="padding-left: 16px; text-align: left;font-size: 14px;">{{item.replace("_"," ")}} (ETA 4 Hours)</div>
                                    <div v-else-if="item == 'FLASH_CAR'" style="padding-left: 16px; text-align: left;font-size: 14px;">{{item.replace("_"," ")}} (ETA 4 Hours)</div>
                                    <div v-else-if="item == 'STANDARD'" style="padding-left: 16px; text-align: left;font-size: 14px;">{{item.replace("_"," ")}} COURIER</div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <!-- lalamove -->
                    <div v-else-if="serviceType.delivery_service == 'lalamove'">
                        <div :key="index" v-for="(item, index) in serviceType.service_type">
                            <div :class="store.is_rain == 1 && item.includes('BIKE')? 'disable':''" @click="if(store.is_rain == 1 && item.includes('BIKE')){ return false} else {return submit(item)}" class="delivery">
                                <div style="display: flex; align-items: center; padding: 0 16px; margin: 6px 0;">
                                    <div>
                                        <icon v-if="item.includes('BIKE')" :color="store.is_rain == 1 && item.includes('BIKE')? '#999':'#ee2d24'" size="20px" name="motorcycle"/>
                                        <icon v-else-if="item.includes('CAR')" class="buttonIcon" size="20px" name="car"/>
                                        <icon v-else-if="item.includes('VAN')" class="buttonIcon" size="20px" name="shuttle-van"/>
                                        <icon v-else-if="item.includes('TRUCK')" class="buttonIcon" size="20px" name="truck"/>
                                    </div>
                                    <div v-if="item == 'BIKE'" style="padding-left: 16px; text-align: left;font-size: 14px;">{{item}}</div>
                                    <div v-else-if="item == 'CAR'" style="padding-left: 16px; text-align: left;font-size: 14px;">{{item}}</div>
                                    <div v-else-if="item == 'VAN'" style="padding-left: 16px; text-align: left;font-size: 14px;">{{item}}</div>
                                    <div v-else-if="item == 'TRUCK4X4'" style="padding-left: 16px; text-align: left;font-size: 14px;">{{item.replace("4X4"," 4X4")}}</div>
                                    <div v-else-if="item == 'TRUCK330'" style="padding-left: 16px; text-align: left;font-size: 14px;">{{item}}</div>
                                    <div v-else-if="item == 'TRUCK550'" style="padding-left: 16px; text-align: left;font-size: 14px;">{{item}}</div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <!-- delyva -->
                    <div v-else-if="serviceType.delivery_service == 'delyva'" style="overflow-y:auto;">
                        <div :key="index" v-for="(item, index) in serviceType.servicePartners">
                            <div :class="item.availability == 'disable'? 'disable':''" @click="if(item.availability == 'disable'){ return false} else {return submit(item)}" class="delivery">
                                <div style="display: flex; align-items: center; padding: 0 16px; margin: 6px 0;justify-content:space-between;">
                                    <div>
                                        <img v-if="item.thumbnail != ''" class="buttonIcon" :color="item.availability == 'disable'? '#999':'#ee2d24'" width="20px" height="20px" :src="item.thumbnail"/>
                                        <van-icon v-else class="buttonIcon"  :color="item.availability == 'disable'? '#999':'#ee2d24'" size="20px" name="logistics" />
                                    </div>
                                    <div style="padding:0 16px; text-align: left;font-size: 14px;flex:1;">{{item.desc}}</div>
                                    <div>{{item.amount.toLocaleString('en-US',{style: 'currency',currency: item.currency,})}}</div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <!-- tadago -->
                    <div v-else-if="serviceType.delivery_service == 'tadago'" style="overflow-y:auto;">
                        <div :key="index" v-for="(item, index) in serviceType.servicePartners">
                            <div :key="key" v-for="(item_service, key) in serviceType.service_type">
                                <div v-if="item_service == item.code" :class="item.availability == 'disable'? 'disable':''" @click="if(item.availability == 'disable'){ return false} else {return submit(item)}" class="delivery">
                                    <div style="display: flex; align-items: center; padding: 0 16px; margin: 6px 0;justify-content:space-between;">
                                        <div>
                                            <icon v-if="item.code.includes('BIKE')" :color="item.availability == 'disable'? '#999':'#ee2d24'" size="20px" name="motorcycle"/>
                                            <icon v-else-if="item.code.includes('CAR')" color="#ee2d24" size="20px" name="car"/>
                                        </div>
                                        <div style="padding:0 16px; text-align: left;font-size: 14px;flex:1;">{{item.desc.replace("/","/")}}</div>
                                        <div>{{item.amount.toLocaleString('en-US',{style: 'currency',currency: item.currency})}}</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </div>
    </van-overlay>
</template>
<script>
import Loading from '@/components/common/Loading.vue'
export default {
components: {Loading},
    props: {
        confirm: {
            type: Function
        },
        cancel: {
            type: Function
        },
        store: {
            type: Object
        },
        serviceType: {
            type: Object
        },
        disableOption: {
            type: Boolean
        },
    },
    data() {
        return {
            requested: false,
            show: true,
            width: '250',
            color: '#fff',
            textSize: '14px',
            expand: false
        }
    },
    created() {
        console.log('store current info',this.store, 'this service type ChooseFeature.vue',this.serviceType)
    },
    methods: {
        checkItem(item){
            if((item == 'STANDARD' && this.disableOption == true) || (this.store.is_rain == 1 && item.includes('BIKE'))){ 
                return this.submit(item)
            } 
            else if(this.disableOption == false){ 
                return this.submit(item)
            }
        },
        close() {
            this.show = false;
            this.cancel();
        },
        submit(item) {
            console.log('Confirm delivery option...',item);
            if (this.serviceType.delivery_service == 'delyva' || this.serviceType.delivery_service == 'tadago'){
                this.serviceType.choosedService = item.code;
                this.serviceType.descService = item.desc;
                this.serviceType.totalFee = item.amount;
                this.serviceType.totalFeeCurrency = item.currency;
                console.log('this.serviceType',this.serviceType)
                this.requested = true;
                this.confirm();
            } else {
                if (item == 'STANDARD'){
                    this.serviceType.choosedService = 'STANDARD_24';
                    this.requested = true;
                    this.confirm();
                } else {
                    this.serviceType.choosedService = item;
                    this.requested = true;
                    this.confirm();
                }
            }
        },
    }
}
</script>
<style lang="less" scoped>
@import url('../../assets/css/common.less');
.wrapper {
    display: grid;
    place-items: center;
    height: 100%;
    width: 100%;
}

.block {
    background-color: #f2f2f2;
    border-radius: 6px;
    min-width: 250px;
}

.flex {
    align-items: center;
    padding: 6px;
}

.icon-text {
    padding-left: 6px;
}

.title {
    text-align: center;
    padding: 16px 16px 10px 55px;
    font-weight: 700;
    border-top-left-radius: 6px;
    border-top-right-radius: 6px;
    span{
        font-size: 1rem;
    }
}

.content {
    padding: 6px;
    display: contents;
}

.btn-action {
    display: flex;
    flex: 1;
    cursor: pointer;
}

.delivery {
    margin: 6px; 
    padding: 6px 0; 
    background-color: #fff;
    border-radius: 6px;
}

.transport {
    animation: van-fade-in 1s;
    margin: 6px;
    margin-left: 50px;
    padding: 6px 0;
    border-radius: 6px;
    width: fit-content;
}

.info {
    text-align: center;
    font-size: 18px;
    background: transparent !important;
}

.close {
    float: right;
    padding: 16px;
    color: #fff;
}

.disable {
    color: #999;
}
</style>